import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=0541ffd0&scoped=true"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetails.vue?vue&type=style&index=0&id=0541ffd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541ffd0",
  null
  
)

export default component.exports